<section
  *ngIf="flexSheetService?.getCurrentWorkBook().isPlaceHolder === false && flexSheetService?.getCurrentWorkSheet()?.isPlaceHolder == true">
  <div class="empty-content flex flex-row justify-center items-center full-grow-no-shrink-no-basis " >
    <div class="text-container">
      <img
        src="https://s3-us-west-2.amazonaws.com/orbitaxservices.com/orbitax-assets/images/orbitax-images/reports-empty.png"
        alt="Empty images">
      <h1>Configure your Worksheet here...</h1>
      <div class="text"> Please select <span> {{flexSheetService?.getCurrentWorkSheet()?.name}}</span> Worksheet by
        clicking <a (click)="configureWorksheetPlaceHolder()"> Configuration Sheet </a>
      </div>
    </div>
  </div>
</section>


<section *ngIf="flexSheetService?.getCurrentWorkBook().isPlaceHolder === true">
  <div class="contents">
    <button mat-button class="browser-btn"
            data-copilot="placeholder-btn-select-file"
            [disabled]="flexSheetService?.isReadonly"
            (click)="openFileSelector()"><i
      class="fa-solid fa-up-from-line"></i>Select File
    </button>
    <p *ngIf="isDownloadFileExists()" (click)="downloadFile()">Download a blank <a >{{flexSheetService?.getCurrentWorkBook()?.name}}</a> import template</p>
    <p *ngIf="!isDownloadFileExists()" >Upload {{flexSheetService?.getCurrentWorkBook().name}} template</p>
  </div>


</section>



